import React, { useState, useEffect } from "react";
import "./Search.css";
import SearchBox from "../Searchbox/Search";
import api from "../../../services/baseUrl";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "./Modal";
import download from "downloadjs";
import DefaultTable from "./Tables/DefaultTable";
import DraftSearchTable from "./Tables/ContentNoTitleTable";
import TambActNoActNamePublicationTable from "./Tables/TambActNoActNamePublicationTable";
import TitleReprintDate from "./Tables/TItleReprintDate";
import DRBillsGazettedBillsNamePublication from "./Tables/DRBillsGazettedBillsNamePublication";
import UMATable from "./Tables/UMATable";
import Pagination from "../../../components/Pagination";
import Cookies from "js-cookie";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import GlobalTable from "./Tables/GlobalTable";

export default function Search() {
  const location = useLocation();
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searched, setSearched] = useState(false);
  const [file, setFile] = useState(null);
  const [libraryId, setLibraryId] = useState(location.state?.libraryId || "");
  const [isGlobal, setIsGlobal] = useState(false);
  const [isContent, setIsContent] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasActNo, setHasActNo] = useState(true);
  const [libraries, setLibraries] = useState([]);
  const payload = location.state?.payload;
  const [language, setLanguage] = useState("EN");
  const [totalResults, settotalResults] = useState(0);
  const [isBilingual, setIsBilingual] = useState(false);
  const englishLibraries = [301, 303, 308, 378];
  const malayLibraries = [300, 302, 309, 379];
  const [fileUUID, setFileUUID] = useState("");
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [currentPage, setCurrentPage] = useState(0);
  const [hasGazetteNo, setHasGazetteNo] = useState(false);
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const packageModel = JSON.parse(cookie).packageModel;
  useEffect(() => {
    const libraryWithActNo = [300, 301, 302, 303, 306, 307, 308, 309];
    const englishLibraries = [301, 303, 308, 378];
    const malayLibraries = [300, 302, 309, 379];
    setSearched(false);
    setLoading(true);
    const fetchLibraries = async () => {
      if (libraryId) {
        try {
          const response = await api.get(
            `/api/egazette-documents/libraries/${libraryId}`
          );
          setLibraries(response.data);
        } catch (err) {
          console.error(err);
        }
      }
    };

    const fetchDocuments = async () => {
      if (libraryId) {
        try {
          const response = await api.post(
            "/egazette/default",
            { libraryId, limit: 10, offset: 0 },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          // settotalResults(response.data);
          setDocumentList(response.data);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      }
    };

    const checkActNo = () => {
      if (!libraryWithActNo.includes(libraryId)) {
        setHasActNo(false);
      }

      if (
        malayLibraries.includes(libraryId) ||
        englishLibraries.includes(libraryId)
      ) {
        setIsBilingual(true);
        if (malayLibraries.includes(libraryId)) {
          setLanguage("BM");
        } else {
          setLanguage("EN");
        }
      } else {
        setIsBilingual(false);
      }
    };

    const handleGlobalSearch = async () => {
      setHasGazetteNo(true);
      setLoading(true);
      setQuery(payload.query);
      setSearched(true);
      let finalPayload = {};
      let endpoint = "";
      if (payload.type === "content") {
        setIsContent(true);
        endpoint = "/search/cont/egazette";
        if (
          packageModel.packageCode === 1 ||
          packageModel.packageCode === "1"
        ) {
          endpoint = "/search/cont/egazette";
        } else {
          endpoint = "/search/cont/egazette/package-b";
        }
        finalPayload = {
          stateId: 14,
          query: payload.query,
          search: payload.search,
        };
      } else {
        setIsContent(false);
        if (
          packageModel.packageCode === 1 ||
          packageModel.packageCode === "1"
        ) {
          endpoint = "/search/meta/egazette/global";
        } else {
          endpoint = "/search/meta/egazette/package-b";
        }
        finalPayload = {
          query: payload.query,
          type: payload.type,
        };
      }
      try {
        const response = await api.post(endpoint, finalPayload, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          setDocumentList(response.data.results || response.data);
        } else {
          console.error("Search failed:", response.statusText);
        }
      } catch (error) {
        console.error("An error occurred:", error);
      } finally {
        setLoading(false);
      }
    };
    if (payload !== null && payload !== undefined) {
      setIsGlobal(true);

      handleGlobalSearch();
    }

    if (libraryId) {
      setIsGlobal(false);
      fetchDocuments();
      fetchLibraries();
      checkActNo();
    }
  }, [libraryId, payload, packageModel.packageCode]);

  useEffect(() => {
    const endOffset = itemOffset + limit;
    setCurrentItems(documentList.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(documentList.length / limit));
    settotalResults(documentList.length);
  }, [itemOffset, limit, documentList]);

  const handleGlobalSearch = async () => {
    setLoading(true);
    setQuery(payload.query);
    setSearched(true);
    setIsGlobal(true);
    let endpoint = "";

    if (payload.type === "content") {
      setIsContent(true);
      endpoint = "/search/cont/egazette";
    } else {
      setIsContent(false);
      endpoint = "/search/meta/egazette/global";
    }

    try {
      const response = await api.post(endpoint, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setDocumentList(response.data.results || response.data);
      } else {
        console.error("Search failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (
    searchQuery,
    limit = 50,
    search,
    offset,
    library = libraryId
  ) => {
    if (libraryId === "") {
      if (payload) {
        payload.limit = limit;
        payload.query = searchQuery;
        if (search === "keyword" || search === "semantic") {
          payload.type = "content";
          payload.search = search;
        } else {
          payload.search = "keyword";
          payload.type = search;
        }
      }
      handleGlobalSearch();
      return;
    }
    setIsGlobal(false);
    setQuery(searchQuery);
    setSearched(true);

    let requestPayload = null;
    let endpoint = "";

    if (search === "semantic" || search === "keyword") {
      setIsContent(true);
      endpoint = "/search/cont/egazette";
      requestPayload = {
        query: searchQuery,
        type: "content",
        modules: "egazette",
        search: search,
        library,
        limit,
        offset: offset,
      };
    } else {
      setIsContent(false);
      endpoint = "/search/meta/egazette";
      requestPayload = {
        query: searchQuery,
        type: search,
        libraryId: library,
      };
    }

    setLoading(true);

    try {
      const response = await api.post(endpoint, requestPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setDocumentList(response.data.results || response.data);
      } else {
        console.error("Search failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  const openModal = async (uuid, pageNumber) => {
    setPageNumber(pageNumber);
    setFileUUID(uuid);
    fetchPdf(uuid);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFile(null);
  };

  const handleLibraryChange = (selectedLibrary) => {
    setLibraryId(Number(selectedLibrary));
  };

  const downloadPdf = async (uuid) => {
    try {
      const response = await api.post(
        "/document/pdf/download",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileNameResponse = await api.post(
        "/document/pdf/getFileName",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const fileName = fileNameResponse.data;

      const contentType = response.headers["content-type"];
      download(response.data, fileName.split("/").pop(), contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const fetchPdf = async (uuid) => {
    try {
      const response = await api.post(
        "/document/pdf",
        { fileUUID: uuid },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const pdfData = response.data.pdfData;

      const byteCharacters = atob(pdfData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setFile(url);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const renderTable = () => {
    if (isGlobal)
      return (
        <GlobalTable
          documentList={currentItems}
          openModal={openModal}
          query={query}
          getArrowIcon={getArrowIcon}
          handleSortGlobal={handleSortGlobal}
        />
      );
    switch (libraryId) {
      case 300:
      case 301:
      case 302:
      case 303:
        return (
          <TambActNoActNamePublicationTable
            documentList={currentItems}
            openModal={openModal}
            query={query}
            language={language}
            handleSortDocument={handleSortDocument}
            getArrowIcon={getArrowIcon}
          />
        );
      case 378:
      case 379:
        return (
          <TitleReprintDate
            documentList={currentItems}
            openModal={openModal}
            query={query}
            handleSortDocument={handleSortDocument}
            getArrowIcon={getArrowIcon}
            handleSortTitle={handleSortTitle}
          />
        );

      case 308:
      case 309:
        return (
          <DRBillsGazettedBillsNamePublication
            documentList={currentItems}
            openModal={openModal}
            downloadPdf={downloadPdf}
            query={query}
            handleSortBills={handleSortBills}
            handleSortDocument={handleSortDocument}
            getArrowIcon={getArrowIcon}
          />
        );

      case 380:
        return (
          <UMATable
            documentList={currentItems}
            openModal={openModal}
            downloadPdf={downloadPdf}
            query={query}
            handleSortDocument={handleSortDocument}
            getArrowIcon={getArrowIcon}
            handleSortTitle={handleSortTitle}
          />
        );

      default:
        return (
          <DefaultTable
            documentList={currentItems}
            openModal={openModal}
            downloadPdf={downloadPdf}
            query={query}
            handleSortDocument={handleSortDocument}
            handleSortTitle={handleSortTitle}
            getArrowIcon={getArrowIcon}
          />
        );
    }
  };

  const handleSortGlobal = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    let sortedList = [...documentList].sort((a, b) => {
      let aValue = a[key]?.toLowerCase().trim() || "";
      let bValue = b[key]?.toLowerCase().trim() || "";

      const aIsNumber = !isNaN(aValue) && aValue !== "";
      const bIsNumber = !isNaN(bValue) && bValue !== "";

      if (aIsNumber && bIsNumber) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDocumentList(sortedList);
    setSortConfig({ key, direction });
    setItemOffset(0);
    setCurrentPage(0);
  };

  const handleSortDocument = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    let sortedList = [...documentList].sort((a, b) => {
      let aValue = a.egDocumentDto[key]?.toLowerCase().trim() || "";
      let bValue = b.egDocumentDto[key]?.toLowerCase().trim() || "";

      const aIsNumber = !isNaN(aValue) && aValue !== "";
      const bIsNumber = !isNaN(bValue) && bValue !== "";

      if (aIsNumber && bIsNumber) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDocumentList(sortedList);
    setSortConfig({ key, direction });
    setItemOffset(0);
    setCurrentPage(0);
  };

  const handleSortBills = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    let sortedList = [...documentList].sort((a, b) => {
      const getValue = (doc) => {
        const attribute = doc.egDocumentDto.egCustomAttributeValue.find(
          (attr) => attr.attributeID.attributeID === 253
        );
        return attribute ? attribute.value?.toLowerCase().trim() : "";
      };

      let aValue = getValue(a);
      let bValue = getValue(b);

      const aIsNumber = !isNaN(aValue) && aValue !== "";
      const bIsNumber = !isNaN(bValue) && bValue !== "";

      if (aIsNumber && bIsNumber) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDocumentList(sortedList);
    setSortConfig({ key, direction });
    setItemOffset(0);
    setCurrentPage(0);
  };

  const handleSortTitle = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedList = [...documentList].sort((a, b) => {
      let aValue = a.egDocumentDto.titles?.[0]?.[key]?.toLowerCase() || "";
      let bValue = b.egDocumentDto.titles?.[0]?.[key]?.toLowerCase() || "";

      const aIsNumber = !isNaN(aValue) && aValue !== "";
      const bIsNumber = !isNaN(bValue) && bValue !== "";

      if (aIsNumber && bIsNumber) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDocumentList(sortedList);
    setSortConfig({ key, direction });
    setItemOffset(0);
    setCurrentPage(0);
  };

  const getArrowIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? (
        <TiArrowSortedUp size={18} className="case-law-arrow-up" />
      ) : (
        <TiArrowSortedDown size={18} className="case-law-arrow-down" />
      );
    } else {
      return <TiArrowUnsorted size={18} />;
    }
  };

  const switchLanguage = (library) => {
    if (englishLibraries.includes(library)) {
      const position = englishLibraries.indexOf(library);
      const newLibrary = malayLibraries[position];
      setLibraryId(newLibrary);
    }
    if (malayLibraries.includes(library)) {
      const position = malayLibraries.indexOf(library);
      const newLibrary = englishLibraries[position];
      setLibraryId(newLibrary);
    }
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * limit) % documentList.length;
    setItemOffset(newOffset);

    const syariahBody = document.querySelector(".egazette-search-body");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
    setCurrentPage(event.selected);
  };

  return (
    <>
      <div className="egazette-search-body">
        <div style={{ padding: "0 25px" }}>
          <SearchBox
            currentLibrary={libraryId}
            libraries={libraries}
            onSearch={handleSearch}
            placeholder={"Enter keyword to search"}
            hasActNo={hasActNo}
            onLibrariesChange={handleLibraryChange}
            defaultSearchEnable={true}
            setLanguage={setLanguage}
            language={language}
            switchLanguage={switchLanguage}
            isBilingual={isBilingual}
            libraryId={libraryId}
            limit={limit}
            setLimit={setLimit}
            hasGazetteNo={hasGazetteNo}
          />
        </div>
        <div className="egazette-content">
          {!loading ? (
            <>
              {!searched ? (
                renderTable()
              ) : searched && documentList.length > 0 ? (
                <div className="egazette-search-content">
                  {isContent ? (
                    <DraftSearchTable
                      openModal={openModal}
                      query={query}
                      searchResults={currentItems}
                    />
                  ) : (
                    renderTable()
                  )}
                </div>
              ) : (
                searched && (
                  <div style={{ textAlign: "center", marginTop: 40 }}>
                    No results found
                  </div>
                )
              )}
            </>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </div>
          )}
        </div>
      </div>

      {!isContent && (
        <Pagination
          handlePageClick={handlePageClick}
          pageCount={pageCount}
          currentPageNumber={currentPage}
          totalResult={totalResults}
          limit={limit}
          offset={itemOffset}
        />
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        keyword={query}
        pdf={file}
        pageNumber={pageNumber}
        fileUUID={fileUUID}
        downloadPdf={downloadPdf}
      />
    </>
  );
}
